import { createContext, useContext, FC, PropsWithChildren } from "react";

import { ThemedBackgroundShapes } from "@/features/FormV2/sharedComponents/BackgroundShapes/ThemedBackgroundShapes";
import { useBackgroundShapesState } from "@/features/FormV2/sharedComponents/BackgroundShapes/useBackgroundShapesState";

interface ShapesContextType {
  rotate: (shapeId?: string) => void;
  drop: (shapeId?: string) => void;
  reverseRotate: (shapeId?: string) => void;
  up: (shapeId?: string) => void;
}

const ShapesContext = createContext<ShapesContextType>({
  rotate: () => {},
  drop: () => {},
  reverseRotate: () => {},
  up: () => {},
});

export const useShapes = (): ShapesContextType => {
  return useContext(ShapesContext);
};

export const ShapesProvider: FC<PropsWithChildren<{ enabled: boolean }>> = ({ children, enabled }) => {
  const { rotate, drop, reverseRotate, up, shapesData } = useBackgroundShapesState();

  const contextValue: ShapesContextType = {
    rotate,
    drop,
    reverseRotate,
    up,
  };

  return (
    <ShapesContext.Provider value={contextValue}>
      <ThemedBackgroundShapes {...shapesData} showShapes={enabled} />
      {children}
    </ShapesContext.Provider>
  );
};
